import {PaginatedApi} from '../types/api/paginatedApi';
import {AssetsTableRecord} from '../types/api/assets';

export const REPORT_STATUS = {
  ERROR: "ERROR",
  WARNING: "WARNING",
  OK: "OK"
} as const;

// Tipo derivato automaticamente dai valori dell'oggetto
export type ERROR_STATUS = typeof REPORT_STATUS.ERROR;
export type WARNING_STATUS = typeof REPORT_STATUS.WARNING;
export type OK_STATUS = typeof REPORT_STATUS.OK;
export type REPORT_DETAIL_STATUS = ERROR_STATUS | WARNING_STATUS | OK_STATUS;

// Array dei valori (utile per iterazioni)
export const REPORT_STATUS_VALUES = Object.values(REPORT_STATUS);

export interface ImportReport {
  'uuid': string,
  'status': string,
  'date_creation': string,
  'created': number,
  'updated': number,
  'errors': number,
  'warnings': number,
  'success': number,
  'rows_analyzed': number
}

export interface GetPaginatedImportReports extends PaginatedApi {
  results: ImportReport[];
}

export type AssetReport = Pick<AssetsTableRecord, 'uuid' | 'sigi_code' | 'country' | 'admin_level_1' | 'admin_level_2' | 'admin_level_3' | 'address' | 'postal_code'>

export interface ImportReportDetail {
  'uuid': string,
  'asset': AssetReport,
  'status': REPORT_DETAIL_STATUS,
  'operation': 'CREATE' | 'UPDATE',
  'is_resolved': boolean | null
}

export interface errorCode {
  csv: string,
  desc: string,
  field: string,
  geocoder: string
}

export interface Comparison {
  csv: string,
  field: string,
  geocoder: string,
  status: REPORT_DETAIL_STATUS
}

export interface ImportReportDetailAsset {
  uuid: string,
  changedData: any[],
  error_data: errorCode[],
  extra_data: {
    address_string: string,
    comparison: Comparison[]
  },
  is_resolved: boolean,
  warning_data: errorCode[]
}